import React, { useState } from 'react';
import { useFormikContext } from 'formik';
import { Icons } from '../Icons/Icons';
import { AddResourceFormValues } from '../ResourceForm/types';
import './FileAttachment.scss';

interface FileAttachmentProps {
  label: string;
}

export const FileAttachment: React.FC<FileAttachmentProps> = ({ label }) => {
  const [selectedFileName, setSelectedFileName] = useState<string>('');
  const { setFieldValue, setFieldTouched, submitCount, values } =
    useFormikContext<AddResourceFormValues>();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedFileName(file.name);
      setFieldValue('file', file);
      setFieldTouched('file', true, true);
    }
  };

  const handleInputClick = () => {
    const fileInput = document.getElementById('file-input');
    fileInput?.click();
  };

  const showError = submitCount > 0 && !values.file && values.type === 'file';
  const errorClass = showError ? 'error' : '';

  return (
    <div className="form-group">
      <label>{label}</label>
      <div className="input-wrapper">
        <input
          type="text"
          readOnly
          value={selectedFileName}
          placeholder="Attach file"
          className={errorClass}
          onClick={handleInputClick}
        />
        <label className="file-input-label">
          {Icons.Paperclip}
          <input
            id="file-input"
            type="file"
            onChange={handleFileChange}
            style={{ display: 'none' }}
          />
        </label>
      </div>
      {showError && <div className="error">File is required</div>}
    </div>
  );
};
